import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as DownLeftArrow } from '../../../../../../assets/icons/v3/down-left-arrow.svg';
import { ReactComponent as UpRightArrow } from '../../../../../../assets/icons/v3/out.svg';
import BdsActivityPill from '../../../../../../shared/components/v3/BdsActivityPill/BdsActivityPill';
import ProportionBar from '../../../../../../shared/components/v3/Charts/ProportionBar/ProportionBar';
import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';

import './DonationsData.scss';

export const DonationsData = ({ data, inDownloadMode }: { data: IHealthReport; inDownloadMode?: boolean }) => {
  const { t } = useTranslation();

  const proportionBarData = useMemo(() => {
    if (!data?.topCauses) return [];
    return data.topCauses.map((item) => ({
      label: item.label,
      value: item.value
    }));
  }, [data]);

  const renderComparisons = (value: number) => {
    if (data.isFirstReport) return;
    if (value >= 0) {
      return (
        <BdsActivityPill
          variant="filled"
          className="dd-pill positive"
          pictogram={{ component: UpRightArrow }}
          label={<div>{value + '%'}</div>}
        />
      );
    }
    return (
      <BdsActivityPill
        variant="filled"
        className="dd-pill negative"
        pictogram={{ component: DownLeftArrow }}
        label={<div>{Math.abs(value) + '%'}</div>}
      />
    );
  };

  return (
    <div className="donations-data-container">
      <div className="health-report-section-subtitle">{t(TRANSLATIONS_REPORTS.healthReport.donationsData.title)}</div>
      <div className="dd-info">
        <div className="dd-info-item">
          <div className="dd-info-value">{data.totalDonations}</div>
          <div className="dd-info-label">
            {t(TRANSLATIONS_REPORTS.healthReport.donationsData.totalDonationsLabel, { count: data.totalDonations })}
          </div>
          {renderComparisons(data.totalDonationsInsight)}
        </div>
        <div className="dd-info-item">
          <div className="dd-info-value">{data.totalFoundations}</div>
          <div className="dd-info-label">
            {t(TRANSLATIONS_REPORTS.healthReport.donationsData.totalFoundationsLabel, { count: data.totalFoundations })}
          </div>
          {renderComparisons(data.totalFoundationsInsight)}
        </div>
        <div className="dd-info-item">
          <div className="dd-info-value">{data.totalDonorUsers}</div>
          <div className="dd-info-label">
            {t(TRANSLATIONS_REPORTS.healthReport.donationsData.totalDonorUsersLabel, { count: data.totalDonorUsers })}
          </div>
          {renderComparisons(data.totalDonorUsersInsight)}
        </div>
      </div>
      {proportionBarData.length > 0 && (
        <div className="dd-savings-chart">
          <ProportionBar data={proportionBarData} isStatic={inDownloadMode} />
        </div>
      )}
      <BdsDivider size="s" color="high" />
    </div>
  );
};

export default DonationsData;
